<template>
    <div class="index-articles">

        <div class="main-content">
			<div class="container-fluid">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-10 col-xl-10">

						<!-- Header -->
						<div class="header mt-md-5">
							<div class="header-body">
								<div class="row align-items-center">
									<div class="col">
										<!-- Title -->
										<h1 class="header-title">
											Articles / Blog
										</h1>
									</div>
								</div> <!-- / .row -->
							</div>
						</div>


                        <!-- Content -->
                        <div class="d-flex flew-row">
                            <div class="">
                                <router-link to="/dashboard/articles/add" class="btn btn-primary px-5">
                                    Add
                                </router-link>
                            </div>

                            <div class="ml-auto mb-4">
                                <form id="searchForm">
                                    <div class="input-group  mb-3" id="search">
                                        <input type="text" name="search" class="form-control form-control-appended" placeholder="Search.."
                                            v-model="searchData" v-validate="'required|min:3'" data-vv-as="search"
                                        >
                                        <div class="input-group-append ml-2">
                                            <div class="input-group-button">
                                                <button class="btn btn-primary" @click.prevent="dataSearch($event)">
                                                    <i class="fe fe-search"></i>
                                                </button>

                                                <button class="btn btn-link close-search" @click.prevent="closeSearch($event)" style="display: none">
                                                    <i class="fe fe-x text-danger"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="text-danger">{{ errors.first('search') }}</span>

                                </form>

                            </div>
                        </div>

                        <!-- Articles data -->
                        <div id="blockUI">
                            <div v-show="!isSearch">
                                <!-- Articles -->
                                <div v-show="articles.length > 0">
                                    <div v-for="(article, i) in articles" :key="i">
                                        <div class="card">
                                            <div class="card-body">

                                                <div class="row align-items-center">
                                                    <div class="col-auto">
                                                        <div class="avatar avatar-lg">
                                                            <span v-if="article.image.trim()">
                                                                <img :src="article.image" class="avatar-img rounded">
                                                            </span>
                                                            <!-- <span v-else>
                                                                <img :src="logo" class="avatar-img rounded">
                                                            </span> -->
                                                        </div>
                                                    </div>

                                                    <div class="col ml--2">

                                                        <h4 class="card-title mb-1 name">
                                                            <router-link :to="'/dashboard/articles/'+article.articleid+'/'+article.dash">
                                                                {{ article.title }}
                                                            </router-link>
                                                        </h4>

                                                        <p class="card-text small mb-1" v-html="article.content"></p>

                                                        <p class="card-text small text-muted">
                                                        Added by {{ article.fullname }} on <time datetime="2018-01-03">{{ article.date_created }}</time>
                                                        </p>
                                                        
                                                    </div>
                                                    
                                                    <div class="col-auto">

                                                        <router-link :to="'/dashboard/articles/'+article.articleid+'/'+article.dash" class="btn btn-sm btn-primary"
                                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                                        >
                                                            <i class="fe fe-edit"></i>    
                                                        </router-link>

                                                        

                                                        <button type="button" class="btn btn-danger btn-sm" @click="deleteData(article.articleid, i, $event)"
                                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                                        >
                                                            <i class="fe fe-trash-2"></i>
                                                        </button>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- No articles -->
                                <div v-show="articles.length <= 0">
                                    <div class="card">
                                        <div class="card-body">
                                            <p class="text-center">No data to display</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pagination -->
                                <div class="d-flex flew-row my-5">
                                    <div class="ml-md-auto">

                                        <b-pagination 
                                            size="sm" 
                                            v-model="currentPage"
                                            :total-rows="pagination.total" 
                                            :per-page="pagination.perPage"
                                            label-last-page="pagination.lastLabel"
                                            label-first-page="pagination.firstLabel"
                                            label-prev-page="pagination.previousLabel"
                                            label-next-page="pagination.nextLabel"
                                        >
                                        </b-pagination>
                                       
                                    </div>
                                </div>

                            </div>


                            <!-- Search data -->
                            <div v-show="isSearch">
                                <!-- Articles -->
                                <div v-show="articlesSearch.length > 0">
                                    <div v-for="(article, i) in articlesSearch" :key="i">
                                        <div class="card">
                                            <div class="card-body">

                                                <div class="row align-items-center">
                                                    <div class="col-auto">
                                                        <div class="avatar avatar-lg">
                                                            <span v-if="article.image">
                                                                <img :src="article.image" class="avatar-img rounded">
                                                            </span>
                                                            <span v-else>
                                                                <img :src="logo" class="avatar-img rounded">
                                                            </span>
                                                            
                                                        </div>
                                                    </div>

                                                    <div class="col ml--2">

                                                        <h4 class="card-title mb-1 name"><a href="#!">{{ article.title }}</a></h4>

                                                        <p class="card-text small mb-1" v-html="article.content"></p>

                                                        <p class="card-text small text-muted">
                                                        Added by {{ article.fullname }} on <time datetime="2018-01-03">{{ article.date_created }}</time>
                                                        </p>
                                                        
                                                    </div>
                                                    
                                                    <div class="col-auto">

                                                        <router-link :to="'/dashboard/articles/'+article.articleid+'/'+article.dash" class="btn btn-sm btn-primary"
                                                                data-toggle="tooltip" data-placement="top" title="Edit"
                                                            >
                                                                <i class="fe fe-edit"></i>    
                                                            </router-link>

                                                        <button class="btn btn-danger btn-sm"
                                                            data-toggle="tooltip" data-placement="top" title="Delete" @click="deleteData(article.articleid, i, $event)"
                                                        >
                                                            <i class="fe fe-trash-2"></i>
                                                        </button>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- No search data -->
                                <div v-show="articlesSearch.length <= 0">
                                    <div class="card">
                                        <div class="card-body">
                                            <p class="text-center">No data found for your search</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

					</div>
				</div>
			</div>
        </div>

						
    </div>
</template>

<script>
import editorOption from "@/assets/js/editorsettings.js";
import pagination from "vue-pagination-bootstrap";
import axios from "axios";
import ArticleListComponent from "@/components/backend/ArticleListComponent";

export default {
    components: { pagination, ArticleListComponent },
    name: "Index",
    data() {
        return {
            articles: [],
            pagination: {
                total: 1,
                perPage: 5,
                lastLabel: "Last",
                firstLabel: "First",
                previousLabel: "Previous",
                nextLabel: "Next"
            },
            currentPage: 1,
            articlesSearch: [],
            searchData: "",
            isSearch: false
        };
    },
    metaInfo: {
        title: "Articles"
    },
    watch: {
        currentPage(page, old) {
            this.fetchPaginationData(page);
        }
    },
    methods: {
        fetchPaginationData(page) {
            this.currentPage = page;
            $("#blockUI").block(editorOption.blockOptions);
            axios
                .get(APIURL + "admin/articles/paginate?page=" + page)
                .then(response => {
                    let res = response.data;
                    this.articles = res.data;
                    this.pagination.total = res.total;
                    this.pagination.perPage = res.limit;

                    $("#blockUI").unblock();
                })
                .catch(err => {
                    console.log(err);
                });
        },

        //fetch data
        fetchData() {
            var self = this;
            axios
                .get(APIURL + "admin/articles")
                .then(response => {
                    let res = response.data;
                    this.articles = res.data;
                    this.pagination.total = res.total;
                    this.pagination.perpage = res.limit;
                })
                .catch(err => {
                    console.log(err);
                });
        },

        //delete data
        deleteData(id, index, e) {
            var self = this;
            var btn = e.currentTarget;

            this.$swal({
                title: "Are you sure to delete this?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(result => {
                if (result.value) {
                    $(btn)
                        .attr("disabled", "")
                        .addClass("is-loading is-loading-sm");

                    $.getJSON(
                        APIURL + "admin/articles-delete/" + id,
                        response => {
                            $(btn)
                                .removeAttr("disabled")
                                .removeClass("is-loading is-loading-sm");

                            if (response.status == 200) {
                                self.$swal("", response.msg, "success");

                                if (self.isSearch) {
                                    self.articlesSearch.splice(index, 1);
                                    return;
                                }
                                self.fetchPaginationData(self.currentPage);
                            } else if (response.status == 203) {
                                self.$swal("", response.msg, "error");
                            } else {
                                self.$swal("", response.msg, "error");
                            }
                        }
                    ).catch(err => {
                        console.log(err);
                    });
                }
            });
        },

        //Search data
        dataSearch(e) {
            var self = this;
            var btn = e.currentTarget;
            var search = this.searchData;
            this.$validator
                .validateAll()
                .then(result => {
                    if (result) {
                        $(btn)
                            .attr("disabled", "")
                            .addClass("is-loading is-loading-sm");
                        $.getJSON(
                            APIURL + "admin/articles/search?search=" + search,
                            function(response) {
                                $(btn)
                                    .removeAttr("disabled")
                                    .removeClass("is-loading is-loading-sm");

                                self.articlesSearch = response;
                                self.isSearch = true;
                                $(".close-search").show();
                            }
                        );
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        //Close search
        closeSearch(e) {
            var self = this;
            var btn = e.currentTarget;
            self.articlesSearch = [];
            self.searchData = "";
            self.$validator.reset();

            self.isSearch = false;
            $(btn).hide();
        }
    },
    created() {
        this.fetchData();
    },
    mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/backend/articles/Index.vue